import $ from 'jquery';

export function getFilters(){
 return $.ajax({
    method: "GET",
    dataType: 'json',
    traditional: true,
    xhrFields: {
      withCredentials: true
   },
    url: process.env.REACT_APP_API+"/equipments/filteroptions",
  }).then(res => res.data)
}